import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.css";
import App from "./containers/App/App";
import reportWebVitals from "./reportWebVitals";
import { amplifyConfig } from "./constants/Auth";
import Amplify from "@aws-amplify/core";

Amplify.configure(amplifyConfig);

ReactDOM.render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
